export default "__VITE_ASSET__ptAbSwXv__"